/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */

import {
  HttpClient,
  HttpEvent,
  HttpHeaders,
  HttpParams,
  HttpResponse
} from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { CustomHttpUrlEncodingCodec } from '../encoder';

import { Observable } from 'rxjs';

import { MgmClaimCancelRequest } from '../model/mgmClaimCancelRequest';
import { ResponseB4AListMgmAlertDTO } from '../model/responseB4AListMgmAlertDTO';
import { ResponseB4AListMgmMilestoneStatsDTO } from '../model/responseB4AListMgmMilestoneStatsDTO';
import { ResponseB4AMgmClaimRowDTO } from '../model/responseB4AMgmClaimRowDTO';
import { ResponseB4AMgmClaimsPageDTO } from '../model/responseB4AMgmClaimsPageDTO';
import { ResponseB4AMgmDashboardSummaryDTO } from '../model/responseB4AMgmDashboardSummaryDTO';
import { ResponseB4AMgmPeopleStatsDTO } from '../model/responseB4AMgmPeopleStatsDTO';

import { Configuration } from '../configuration';
import { BASE_PATH } from '../variables';

@Injectable()
export class MgmDashboardControllerService {
  public configuration = new Configuration();

  public defaultHeaders = new HttpHeaders();
  protected basePath = 'http://localhost:8080';
  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration
  ) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   *
   *
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public alerts(
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4AListMgmAlertDTO>;
  public alerts(
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4AListMgmAlertDTO>>;
  public alerts(
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4AListMgmAlertDTO>>;
  public alerts(
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<ResponseB4AListMgmAlertDTO>(
      'get',
      `${this.basePath}/mgm/dashboard/alerts`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param from
   * @param to
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public byMilestone(
    from?: Date,
    to?: Date,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4AListMgmMilestoneStatsDTO>;
  public byMilestone(
    from?: Date,
    to?: Date,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4AListMgmMilestoneStatsDTO>>;
  public byMilestone(
    from?: Date,
    to?: Date,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4AListMgmMilestoneStatsDTO>>;
  public byMilestone(
    from?: Date,
    to?: Date,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec()
    });
    if (from !== undefined && from !== null) {
      queryParameters = queryParameters.set('from', <any>from.toISOString());
    }
    if (to !== undefined && to !== null) {
      queryParameters = queryParameters.set('to', <any>to.toISOString());
    }

    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<ResponseB4AListMgmMilestoneStatsDTO>(
      'get',
      `${this.basePath}/mgm/dashboard/by-milestone`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param body
   * @param claimId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cancelClaim(
    body: MgmClaimCancelRequest,
    claimId: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4AMgmClaimRowDTO>;
  public cancelClaim(
    body: MgmClaimCancelRequest,
    claimId: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4AMgmClaimRowDTO>>;
  public cancelClaim(
    body: MgmClaimCancelRequest,
    claimId: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4AMgmClaimRowDTO>>;
  public cancelClaim(
    body: MgmClaimCancelRequest,
    claimId: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling cancelClaim.'
      );
    }

    if (claimId === null || claimId === undefined) {
      throw new Error(
        'Required parameter claimId was null or undefined when calling cancelClaim.'
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ResponseB4AMgmClaimRowDTO>(
      'post',
      `${this.basePath}/mgm/dashboard/claims/${encodeURIComponent(String(claimId))}/cancel`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param from
   * @param to
   * @param status
   * @param milestone
   * @param queueOnly
   * @param page
   * @param size
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public claims(
    from?: Date,
    to?: Date,
    status?: string,
    milestone?: number,
    queueOnly?: boolean,
    page?: number,
    size?: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4AMgmClaimsPageDTO>;
  public claims(
    from?: Date,
    to?: Date,
    status?: string,
    milestone?: number,
    queueOnly?: boolean,
    page?: number,
    size?: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4AMgmClaimsPageDTO>>;
  public claims(
    from?: Date,
    to?: Date,
    status?: string,
    milestone?: number,
    queueOnly?: boolean,
    page?: number,
    size?: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4AMgmClaimsPageDTO>>;
  public claims(
    from?: Date,
    to?: Date,
    status?: string,
    milestone?: number,
    queueOnly?: boolean,
    page?: number,
    size?: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec()
    });
    if (from !== undefined && from !== null) {
      queryParameters = queryParameters.set('from', <any>from.toISOString());
    }
    if (to !== undefined && to !== null) {
      queryParameters = queryParameters.set('to', <any>to.toISOString());
    }
    if (status !== undefined && status !== null) {
      queryParameters = queryParameters.set('status', <any>status);
    }
    if (milestone !== undefined && milestone !== null) {
      queryParameters = queryParameters.set('milestone', <any>milestone);
    }
    if (queueOnly !== undefined && queueOnly !== null) {
      queryParameters = queryParameters.set('queueOnly', <any>queueOnly);
    }
    if (page !== undefined && page !== null) {
      queryParameters = queryParameters.set('page', <any>page);
    }
    if (size !== undefined && size !== null) {
      queryParameters = queryParameters.set('size', <any>size);
    }

    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<ResponseB4AMgmClaimsPageDTO>(
      'get',
      `${this.basePath}/mgm/dashboard/claims`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param from
   * @param to
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public people(
    from?: Date,
    to?: Date,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4AMgmPeopleStatsDTO>;
  public people(
    from?: Date,
    to?: Date,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4AMgmPeopleStatsDTO>>;
  public people(
    from?: Date,
    to?: Date,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4AMgmPeopleStatsDTO>>;
  public people(
    from?: Date,
    to?: Date,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec()
    });
    if (from !== undefined && from !== null) {
      queryParameters = queryParameters.set('from', <any>from.toISOString());
    }
    if (to !== undefined && to !== null) {
      queryParameters = queryParameters.set('to', <any>to.toISOString());
    }

    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<ResponseB4AMgmPeopleStatsDTO>(
      'get',
      `${this.basePath}/mgm/dashboard/people`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param from
   * @param to
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public summary(
    from?: Date,
    to?: Date,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4AMgmDashboardSummaryDTO>;
  public summary(
    from?: Date,
    to?: Date,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4AMgmDashboardSummaryDTO>>;
  public summary(
    from?: Date,
    to?: Date,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4AMgmDashboardSummaryDTO>>;
  public summary(
    from?: Date,
    to?: Date,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec()
    });
    if (from !== undefined && from !== null) {
      queryParameters = queryParameters.set('from', <any>from.toISOString());
    }
    if (to !== undefined && to !== null) {
      queryParameters = queryParameters.set('to', <any>to.toISOString());
    }

    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<ResponseB4AMgmDashboardSummaryDTO>(
      'get',
      `${this.basePath}/mgm/dashboard/summary`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }
}
